// extracted by mini-css-extract-plugin
module.exports = {"select-input":"select_select-input__2H2Py"};